import React from 'react'

import useIPDetection from '../hooks/useIPDetection'

import styles from './IPStatusPanel.module.css'

interface IPStatusPanelProps {
  onIPChange?: (oldIP: string, newIP: string) => void
}

const IPStatusPanel: React.FC<IPStatusPanelProps> = ({ onIPChange }) => {
  const { ip, isLoading, error, previousIP, hasIPChanged, refresh } =
    useIPDetection({
      pollInterval: 15000,
      onIPChange,
    })

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <span className={styles.headerIcon}>🎯</span>
        <span className={styles.headerTitle}>IP STATUS MONITOR</span>
        <button className={styles.refreshBtn} onClick={refresh} disabled={isLoading}>
          ⟳
        </button>
      </div>

      <div className={styles.content}>
        {isLoading ? (
          <div className={styles.loading}>
            <span className={styles.loadingDots}>SCANNING</span>
          </div>
        ) : error ? (
          <div className={styles.error}>
            <span className={styles.errorIcon}>⚠</span>
            <span>{error}</span>
          </div>
        ) : (
          <>
            <div className={styles.ipDisplay}>
              <div className={styles.ipLabel}>CURRENT IP</div>
              <div className={styles.ipValue}>{ip}</div>
            </div>

            {hasIPChanged && previousIP && (
              <div className={styles.changeAlert}>
                <div className={styles.changeHeader}>
                  IP CHANGE DETECTED
                </div>
                <div className={styles.changeComparison}>
                  <div className={styles.oldIP}>
                    <span className={styles.changeLabel}>BEFORE:</span>
                    <span className={styles.changeValue}>{previousIP}</span>
                  </div>
                  <span className={styles.arrow}>→</span>
                  <div className={styles.newIP}>
                    <span className={styles.changeLabel}>AFTER:</span>
                    <span className={styles.changeValue}>{ip}</span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <div className={styles.scanline} />
    </div>
  )
}

export default IPStatusPanel
